import React from "react";
import AdminHomeContent from "../../components/admin-dashboard/AdminHomeContent";
import AdminDashboardLayout from "../../layout/dashboard/AdminDashboardLayout";

const AdminDashboardPage = () => {
  return (
    <AdminDashboardLayout>
      <AdminHomeContent />
    </AdminDashboardLayout>
  );
};

export default AdminDashboardPage;
